'use client';

import { createContext, useContext } from 'react';

export interface DialogOptions {
  title: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  showDeleteButton?: boolean;
}

export interface DialogState extends DialogOptions {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export interface DialogContextValue {
  state: DialogState;
  open: (options: DialogOptions) => void;
  close: () => void;
}

const DialogContext = createContext<DialogContextValue | undefined>(undefined);

export const DialogContextProvider = DialogContext.Provider;

export function useDialog() {
  const context = useContext(DialogContext);

  if (context === undefined) {
    throw new Error('useDialog must be used within a DialogProvider');
  }

  return context;
}
